import { Provider } from '@angular/core';
import { AppInsightsService } from '@mri-platform/angular-app-insights';
import { ERROR_APPENDERS } from '@mri-platform/angular-error-logging';

export const AppInsightsErrorAppenderProvider: Provider = {
  provide: ERROR_APPENDERS,
  useExisting: AppInsightsService,
  multi: true
};
